export default __webpack_public_path__ + "static/health_card_mobile-2a892fabed0c19e89d406a1a3ed7e895.png";